import { useEffect, useRef } from 'react';
import { useCurrentEditor } from '@tiptap/react';
import { parseTipTapJSONToPlainText, serializePlaceholdersToHtml } from '@helpers/text-editor';

// EditorProvider only consumes `content` at mount; this pushes later `value` changes in via
// setContent when (and only when) editor content diverges, so user keystrokes don't echo.
// Deps are [editor, value] only — `serializerOpts` is read via ref because its identity
// churns every render (useTranslation returns a fresh `t`).
export const ExternalValueSync = ({ value, serializerOpts }) => {
    const { editor } = useCurrentEditor();
    const serializerOptsRef = useRef(serializerOpts);
    serializerOptsRef.current = serializerOpts;
    useEffect(() => {
        if (!editor) return;
        const currentPlain = parseTipTapJSONToPlainText(editor.getJSON());
        if (currentPlain === value) return;
        editor.commands.setContent(serializePlaceholdersToHtml(value || '', serializerOptsRef.current), {
            emitUpdate: false,
        });
    }, [editor, value]);
    return null;
};
